import { Site } from '@envato/foundation-types'
import { ICommonLocation } from '../../../common/utils/location/types'
import { IExperimentsState } from '../../../common/reducers/experiments'

import { getCookie, setCookie } from '../../../common/utils/cookieHelper'
import { hasFeature } from '../../../common/utils/features'

import { Consent } from '../consent'

export const incrementViewsForSurvey = (
  currentSite: Site,
  location: ICommonLocation,
  experiments: IExperimentsState
) => {
  const canShowSurvey = hasFeature(
    'canShowCSATSurvey',
    currentSite,
    location,
    experiments
  )
  if (canShowSurvey) {
    const newCount: number = currentViewsForSurvey() + 1

    if (newCount <= 5) {
      setCookie({
        itemKey: 'page_view_count',
        consentType: Consent.preferences,
        itemValue: newCount.toString()
      })
    }
  }
}

export const currentViewsForSurvey = () => {
  const currentCountAsString: string =
    getCookie({
      itemKey: 'page_view_count',
      consentType: Consent.preferences,
      defaultValue: '0'
    }) || '0'

  return parseInt(currentCountAsString, 10)
}
